const LICENSE_EXPIRED_KEY = "licenseExpired";
const LICENSE_RETURN_KEY = "licenseExpiredReturnTo";
const LICENSE_EVENT = "edge:license-expired";
const LICENSE_TITLES = new Set([
  "LICENSE_EXPIRED",
  "LICENSE_MISSING",
  "LICENSE_NOT_CONFIGURED",
  "LICENSE_INVALID",
]);

export const isLicenseExpiredTitle = (title) => {
  if (!title) return false;
  return LICENSE_TITLES.has(String(title).toUpperCase());
};

export const isLicenseExpiredPayload = (payload) => {
  if (!payload || typeof payload !== "object") return false;
  const title = payload?.title || payload?.error?.title;
  return isLicenseExpiredTitle(title);
};

export const markLicenseExpiredAndRedirect = () => {
  try {
    sessionStorage.setItem(LICENSE_EXPIRED_KEY, "true");
  } catch {
    // ignore
  }
  if (typeof window !== "undefined") {
    try {
      window.dispatchEvent(new Event(LICENSE_EVENT));
    } catch {
      // ignore
    }
  }

  if (typeof window === "undefined") return;

  try {
    const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (!currentPath.startsWith("/license-expired")) {
      sessionStorage.setItem(LICENSE_RETURN_KEY, currentPath);
    }
  } catch {
    // ignore
  }

  if (!window.location.pathname.startsWith("/license-expired")) {
    window.location.replace("/license-expired");
  }
};

export const clearLicenseExpired = () => {
  try {
    sessionStorage.removeItem(LICENSE_EXPIRED_KEY);
    sessionStorage.removeItem(LICENSE_RETURN_KEY);
  } catch {
    // ignore
  }
  if (typeof window !== "undefined") {
    try {
      window.dispatchEvent(new Event(LICENSE_EVENT));
    } catch {
      // ignore
    }
  }
};

export const isLicenseExpiredFlagSet = () => {
  try {
    return sessionStorage.getItem(LICENSE_EXPIRED_KEY) === "true";
  } catch {
    return false;
  }
};

export const getLicenseExpiredReturnTo = () => {
  try {
    return sessionStorage.getItem(LICENSE_RETURN_KEY);
  } catch {
    return null;
  }
};

export const subscribeToLicenseExpiredChanges = (handler) => {
  if (typeof window === "undefined") return () => {};
  window.addEventListener(LICENSE_EVENT, handler);
  return () => window.removeEventListener(LICENSE_EVENT, handler);
};
